/**
 * @param {string} string
 * @param {string} search
 * @returns {boolean}
 */
export function stringContains(string, search) {
  return string.toLowerCase().includes(search.toLowerCase());
}
